<!-- 
    FORM PARA INCLUSAO DE NOVOS PARTICIPANTES NO NEGOCIO
-->

<script>
import Vue from 'vue';
import { SysVars } from '../main';
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        params: {},
    },
    
    components: {
        
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            negociocrm: {...this.$store.getters.getEntities.negociocrm},
            pessoa: null,
            telefones: [],
            emails: [],
            codpessoa: null,

            addingParticipante: false,

            listParticipantes: [],

            inputPessoa: {
                url: '/crm/find/pessoa?nome=',
                permite_novo: true,
                codigo: null,
                icon: 'fa-user', 
            },            

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },           

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            },           

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        isNovoNegocio: function () {
            return !this.params
        },

        habilitaContatos: function () {
            return this.pessoa && this.pessoa.novo
        },

        title: function () {
            return 'Participantes do Negócio'
        },

    },

    methods: {
        handleIncluirPessoa () {
            console.log('fila da puta')
            this.addingParticipante = true
            this.telefones = []
            this.emails = []
            this.codpessoa = null
            this.$nextTick(function () {
                if (this.$refs.pessoa) {
                    this.$refs.pessoa.focus()
                }
            })
        },

        handleSalvar () {
            if (!this.pessoa) {
                this.$refs.pessoa.focus()
                return
            }

            if (this.listParticipantes.filter(obj => { return obj.codpessoa == this.codpessoa }).length > 0) {
              this.addingParticipante = false
              return
            }

            var valido = true;
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    let obj = { codnegocio: this.negociocrm.codnegocio }
                    if (this.pessoa.novo) {
                        this.pessoa.telefones = this.telefones
                        this.pessoa.emails = this.emails
                        obj.dados = { pessoa: this.pessoa }
                        obj.participante = { codpessoa: null }
                    }
                    else
                      obj.participante = { codpessoa: this.pessoa.codpessoa }

                    this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackPost)
                }
            })

        },

        handleDelete (index) {
            this.pessoa = null
            let obj = { codnegocio: this.negociocrm.codnegocio }
            obj.participante = { codpessoa: this.listParticipantes[index].codpessoa, excluido: true }
            
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackPost)
            this.listParticipantes.splice(index, 1)
        },

        callBackPost (negocio) {
            this.addingParticipante = false
            if (this.pessoa) {
                this.negociocrm.participantes = negocio.participantes
                this.listParticipantes = negocio.participantes
            }
        },

        closeForm () {
            this.$emit('closeform')
        },

        // handleIncluirPessoa (text) {
        //     this.pessoa = {
        //         novo: true,
        //         nome: text,
        //     }
        //     this.telefones = []
        //     this.emails = []
        //     this.handleAdicionarEmail()
        //     this.handleAdicionarTelefone()
        // },

        handleSelectPessoa (selected) {
            this.pessoa = selected
            if (this.pessoa) {
                this.pessoa.novo = false
                this.telefones = this.pessoa.telefones
                this.emails = this.pessoa.emails
            }
        },

        /////////////////////////////////// TELEFONES
        handleAdicionarTelefone () {
            this.telefones.push({
                numero: null,
                ramal: null,
                tipofone: '0'
            })
        },

        handleDeleteTelefone (index) {
            this.telefones.splice(index,1)
        },

        /////////////////////////////////// EMAILS
        handleAdicionarEmail() {
            this.emails.push({
                email: null,
                tipoemail: null
            })
        },

        handleDeleteEmail (index) {
            this.emails.splice(index,1)
        },

    },

    watch: {

    },

    mounted () {
        if (this.negociocrm && this.negociocrm.participantes) {
            this.listParticipantes = this.negociocrm.participantes
        }
        if (this.listParticipantes.length == 0)
            this.handleIncluirPessoa()
    },

    created () {
        if (this.params && this.params.negocio) {
           this.negociocrm = this.params.negocio
        }
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; min-width: 500px; max-width: 100%">
            <div class="nb-modal-header">
                <div class="row">
                    <div class="col-md-12 col-12">
                        <h4 class="def-title"> {{ title }} </h4>
                    </div>
                </div>
            </div>
            <div class="nb-modal-scrollable-body">

                <!-- LISTA DE PARTICIPANTES -->
                <div class="mainbox mt-3" v-for="(item, index) in listParticipantes" :key="index">
                    <div class="row mb-2 align-items-center">
                        <div class="col-md-10">
                            <i class="fa fa-user pr-2" aria-hidden="true" style="font-size: 18px"></i>
                            <span class="data-list">{{ item.pessoa[0].nome }}</span>
                        </div>
                        <div class="col-md-2">
                            <v-button label="" icon="fa-trash" class="float-right" @click="handleDelete(index)"></v-button>
                        </div>
                    </div>
                </div>

                <div v-if="!addingParticipante" class="row col mb-2">
                    <v-button label="Adicionar Contato" :link="true" icon="fa-plus" @click="handleIncluirPessoa"></v-button>
                </div>

                <div v-if="addingParticipante">
                    <div class="row">
                        <div class="col-md-12">
                            <input-search ref="pessoa" v-model="codpessoa" @novo="handleIncluirPessoa" @select="handleSelectPessoa" :params="inputPessoa" :metadata="metadata.negociocrm.codpessoa"></input-search>
                        </div>
                    </div>

                    <!-- INCLUSAO DE NOVA PESSOA OBRIGA INFORMAR CONTATOS -->
                    <div v-if="pessoa && pessoa.novo">
                        <!-- telefones -->
                        <div class="row pl-5">
                            <div class="col-12">
                                <v-label label="Telefone"></v-label>
                            </div>
                        </div>
                        <div class="row pl-5" v-for="(fone, index) in telefones" :key="index">
                            <div class="col-md-5">
                                <input-search :params="inputFone" v-model="fone.numero">
                                <!-- :name="'numero' + index" :v-errors="errors" v-validate="metadata.fonecrm.numero.validator"> -->
                                    <a v-if="index == telefones.length-1" style="cursor: pointer; color: #0091ea;" @click="handleAdicionarTelefone">Adicionar Telefone</a>
                                </input-search>
                            </div>
                            <form-field v-model="fone.tipofone" type="select" col="4" 
                                :name="'tipofone' + index" :v-errors="errors" v-validate="metadata.fonecrm.tipofone.validator"></form-field>
                            <div class="col-auto">
                                <v-button v-if="telefones.length>1" icon="fa-trash" @click="handleDeleteTelefone(index)"></v-button>
                            </div>

                        </div>

                        <!-- emails -->
                        <div class="row pl-5">
                            <div class="col-12">
                                <v-label label="Email"></v-label>
                            </div>
                        </div>
                        <div v-for="(email, index) in emails" :key="index">
                            <div class="row pl-5">
                                <div class="col-md-5">
                                    <input-search :params="inputEmail" v-model="email.email">
                                    <!-- :name="'email' + index" :v-errors="errors" v-validate="metadata.emailcrm.email.validator"> -->
                                    <a v-if="index == telefones.length-1" style="cursor: pointer; color: #0091ea;" @click="handleAdicionarEmail">Adicionar Email</a>
                                    </input-search>
                                </div>
                                <form-field v-model="email.tipoemail" type="select" col="4"
                                    :name="'tipoemail' + index" :v-errors="errors" v-validate="metadata.emailcrm.tipoemail.validator"></form-field>
                                <div class="col-md-1 col-1">
                                    <v-button v-if="emails.length>1" icon="fa-trash" @click="handleDeleteEmail(index)"></v-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row align-items-center" v-for="(fone, index) in telefones" :key="index">
                                <div class="col-md-5 pl-5">
                                    <i class="fa fa-phone pr-2" aria-hidden="true"></i>
                                    <span class="data-list"> {{ fone.numero | formatFone }} </span>
                                    <!-- <span class="data-list"> {{ fone.tipofone | getTextOption(metadata.fonecrm.tipofone) }} </span> -->
                                </div>
                        </div>
                        <!-- emails -->
                        <div class="row align-items-center mb-1" v-for="(email, index) in emails" :key="index">
                                <div class="col-md-5 pl-5">
                                    <i class="fa fa-envelope pr-2" aria-hidden="true"></i>
                                    <span class="data-list"> {{ email.email }} </span>
                                    <!-- <span class="data-list"> {{ email.tipoemail | getTextOption(metadata.emailcrm.tipoemail) }} </span> -->
                                </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3 text-right">
                        <v-button label="Cancelar" tabindex="1" @click="addingParticipante = false"></v-button>
                        <v-button label="Salvar" icon="fa-download" :success="true" @click="handleSalvar"></v-button>
                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <v-button label="Fechar" title="" @click="closeForm"></v-button>
            </div>
        </div>
    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-negocio-participantes.vue